/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_EmptyInputs */

const en_cases_empty = /** @type {(inputs: Cases_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No cases yet. Create your first one.`)
};

const pt_br2_cases_empty = /** @type {(inputs: Cases_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum caso ainda. Crie o primeiro.`)
};

/**
* | output |
* | --- |
* | "No cases yet. Create your first one." |
*
* @param {Cases_EmptyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cases_empty = /** @type {((inputs?: Cases_EmptyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_EmptyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cases_empty(inputs)
	return pt_br2_cases_empty(inputs)
});